import { ICountryDetail } from 'types/countries';
import UploadForm from 'views/bulkUpload/components/UploadForm/UploadForm';
import { UploadFormOptionDropdown } from 'views/bulkUpload/components/UploadForm/UploadForm.types';
import { downloadUploadInfo, downloadUploadInfoWithErrors } from '../../content/downloadUploadInfo';
import './DownloadOrdersStep1.scss';

interface DownloadOrdersStep1Props {
  handleUploadFile: (file: File) => Promise<void>;
  selectedCountry: ICountryDetail | null;
  handleSelectedCountry: (value: ICountryDetail) => void;
  countries: ICountryDetail[];
  templateUrlWithErrors?: string;
}

const DownloadOrdersStep1 = ({
  selectedCountry,
  handleSelectedCountry,
  countries,
  templateUrlWithErrors,
  handleUploadFile
}: DownloadOrdersStep1Props) => {
  const dropdownOptions: UploadFormOptionDropdown[] = [
    {
      label: 'País',
      type: 'dropdown',
      options: countries.map(country => ({
        label: country.name ?? '',
        value: country.code ?? '',
        handleChange: () => handleSelectedCountry(country)
      })),
      defaultOption: {
        label: selectedCountry?.name ?? 'Selecciona el país',
        value: selectedCountry?.code ?? '',
        isFilled: !!selectedCountry?.code
      }
    }
  ];

  const renderUploadInfo = templateUrlWithErrors
    ? downloadUploadInfoWithErrors(templateUrlWithErrors)
    : downloadUploadInfo;

  return (
    <UploadForm
      uploadInfo={renderUploadInfo}
      options={dropdownOptions}
      confirmationModal={false}
      onSubmit={handleUploadFile}
      customClassName='download-orders-step1'
    />
  );
};

export default DownloadOrdersStep1;
